module.exports = __webpack_public_path__ + "img/icon_radius4.c0bbbb46.png";